import React from 'react';
import './App.css';
import Home from './home/indexs'

function App() {
  return (
    <>
     <Home/>
    </>
  );
}

export default App;
